import { useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import rulesData from './rulesData'
import { authService } from '../services/authService'
import { updateUser } from '../store/slices/authSlice'
import useModalEnter from '../hooks/useModalEnter'
import Collapse from './Collapse'

function RulesModal({ onClose }) {
  const dispatch = useDispatch()
  const { user, role } = useSelector((state) => state.auth)
  const [activeAccordion, setActiveAccordion] = useState(null)
  const [activeSubAccordion, setActiveSubAccordion] = useState(null)
  const [isAccepting, setIsAccepting] = useState(false)

  const handleAccept = async () => {
    if (isAccepting) return
    setIsAccepting(true)
    try {
      // Send the explicit id from the profile so the exact row gets updated
      await authService.acceptRules(role, role === 'owner' ? user?.owner_id : user?.staff_id)
      dispatch(updateUser({ ...user, rules_accepted: true }))
      // Guard for page refreshes while the profile API doesn't carry the flag yet
      sessionStorage.setItem('rulesModalShown', 'true')
      onClose()
    } catch (error) {
      // Stay open: closing here looked like success while the flag was still
      // false in the DB, so the modal came straight back on the next page.
      console.error('Failed to accept rules:', error)
    } finally {
      setIsAccepting(false)
    }
  }

  const toggleAccordion = (idx) => {
    setActiveAccordion(activeAccordion === idx ? null : idx)
    setActiveSubAccordion(null)
  }

  const toggleSubAccordion = (key) => {
    setActiveSubAccordion(activeSubAccordion === key ? null : key)
  }

  const [langOpen, setLangOpen] = useState(false)

  const { modalClass, backdropClass, onBackdropClick } = useModalEnter(onClose)

  return (
    <div style={{ position: 'absolute', zIndex: 1040 }}>
      <div role="dialog" className={modalClass} style={{ display: 'block' }} aria-modal="true" onClick={onBackdropClick}>
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <header className="modal-header">
              <h5 className="modal-title">Rules</h5>
              <button type="button" className="close" onClick={onClose}>&times;</button>
            </header>
            <div className="modal-body">
              <div className="main-rules-container">
                <div className={`dropdown rules-language-container${langOpen ? ' show' : ''}`}>
                  <div data-toggle="dropdown" aria-expanded={langOpen ? 'true' : 'false'} className="dropdown-toggle" onClick={() => setLangOpen(!langOpen)}>
                    <img src="/admin/assets/flag_english.png" /> English
                    <i className="fas fa-angle-down ml-1"></i>
                  </div>
                  <div
                    className={`dropdown-menu rules-language${langOpen ? ' show' : ''}`}
                    x-placement="bottom-start"
                    style={langOpen ? { position: 'absolute', transform: 'translate3d(0px, 20px, 0px)', top: 0, left: 0, willChange: 'transform' } : undefined}
                  >
                    <div onClick={() => setLangOpen(false)}>
                      <img src="/admin/assets/flag_english.png" /> <span>English</span>
                    </div>
                  </div>
                </div>
                <div className="menu-box">
                  <div id="accordion">
                    {rulesData.map((sport, idx) => (
                      <div className="card" key={idx}>
                        <div id={`eventhead${idx}`} className="card-header">
                          <a href="javascript:void(0)" onClick={() => toggleAccordion(idx)} className={activeAccordion === idx ? '' : 'collapsed'}>
                            {sport.name}
                          </a>
                        </div>
                        {/* Bootstrap collapse slide (components/Collapse), the
                            reference's `data-toggle="collapse"` accordion: the
                            sport's categories grow into view over .35s and the
                            previously open sport shrinks at the same time, then
                            each category's rules do the same one level down.
                            Content stays mounted (display:none when closed), as
                            Bootstrap keeps it. */}
                        <Collapse open={activeAccordion === idx} id={`event${idx}`}>
                          <div className="card-body">
                            {sport.categories.map((cat, cidx) => (
                              <div className="card" key={cidx}>
                                <div className="card-header">
                                  <a href="javascript:void(0)" onClick={() => toggleSubAccordion(`${idx}-${cidx}`)} className={activeSubAccordion === `${idx}-${cidx}` ? '' : 'collapsed'}>
                                    {cat.name}
                                  </a>
                                </div>
                                <Collapse open={activeSubAccordion === `${idx}-${cidx}`} className="card-body">
                                  {cat.rules.map((rule, ridx) => (
                                    <div className={`rule-text${rule.danger ? ' text-danger' : ''}`} key={ridx}>
                                      {rule.text}
                                    </div>
                                  ))}
                                </Collapse>
                              </div>
                            ))}
                          </div>
                        </Collapse>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
              {/* Accept row only while the profile says the rules are NOT yet
                  accepted. Opened from the header link by an account that has
                  already accepted, the modal is read-only (user, 2026-09-18). */}
              {user?.rules_accepted !== true && (
                <div className="row row5 mt-3 align-items-center">
                  <div className="col-7">I have read above rules</div>
                  <div className="col-5 text-right">
                    <button type="button" className="btn btn-success" onClick={handleAccept}>
                      Accept
                    </button>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      <div className={backdropClass}></div>
    </div>
  )
}

export default RulesModal
